import api from '../api'

export function inviteToPlickers(email) {
	return (dispatch) => api.post('/invite',{email:email})
		.then((response) => {
			if(window.analytics){
				window.analytics.track('Invite to Plickers')}
			return response
		})
		.catch((error) => {
			return error
		})
}





// WEBPACK FOOTER //
// ./src/actions/invite.js